module.exports = {
  appendFile: () => {},
  writeFile: () => {},
  readFile: () => {},
  readFileSync: () => {},
  readdir: () => {},
  lstat: () => {},
  chmod: () => {},
  unlink: () => {},
  stat: () => {},
  truncate: () => {},
  access: () => {},
  accessSync: () => {},
  copyFile: () => {},
  copyFileSync: () => {},
  unlinkSync: () => {},
  rename: () => {},
  renameSync: () => {},
  writev: true,
};
